<template>
  <router-view />
</template>

<script>
export default {
  name: 'SharedLink'
};
</script>
